module.exports = __webpack_public_path__ + "img/step2-c.2e456ec6.png";